import { t } from "@lingui/core/macro";
import { TemplateShiftTime } from "./TemplateShiftTime";
import { CompetenceChip } from "@/components/Chips/CompetenceChip";
import { activityRequirementStatusSchema } from "@medoma/models/activities";
import { shiftTypesDictionary, type ShiftPreset } from "@medoma/models/shifts";
import { Text } from "@medoma/components/Text/Text";
import styles from "./ShiftTemplateItem.module.scss";

export const ShiftTemplateItem = ({ template }: { template: ShiftPreset }) => (
  <div className={styles.shiftTemplateItem}>
    <CompetenceChip
      competence={template.competence}
      state={activityRequirementStatusSchema.enum.neutral}
      size="medium"
    />
    <TemplateShiftTime
      startTime={template.startTime}
      endTime={template.endTime}
    />
    {template.shiftType ? (
      <Text element="div" color="faded" size="small">
        {t(shiftTypesDictionary[template.shiftType])}
      </Text>
    ) : null}
  </div>
);
